const PUBLIC_API_URL = import.meta.env.VITE_TCGATE_PUBLIC_API_URL;

export function buildApiUrl(path: string, queryParams?: URLSearchParams): string {
    const url = new URL(path, `${PUBLIC_API_URL}`);
    if (queryParams) {
        url.search = queryParams.toString();
    }
    return url.toString();
}